import React, { lazy } from 'react';
const tomes = [{
  label: '0–6m',
  sublabel: 'Reflejos y vínculo',
  image: 'https://i.ibb.co/r2Q0Bxhc/b5626039-c54e-43d6-914c-a904f099dc3a-2.png'
}, {
  label: '6–12m',
  sublabel: 'Exploración sensorial',
  image: 'https://i.ibb.co/Rk8rb9wq/Chat-GPT-Image-19-abr-2026-12-02-30.png'
}, {
  label: '12–18m',
  sublabel: 'Primeros pasos',
  image: 'https://i.ibb.co/mFt2FF8J/Chat-GPT-Image-19-abr-2026-12-03-30.png'
}, {
  label: '18–24m',
  sublabel: 'Lenguaje y juego',
  image: 'https://i.ibb.co/Y5R7cC1/Chat-GPT-Image-19-abr-2026-12-05-47.png'
}, {
  label: '24–30m',
  sublabel: 'Motricidad fina',
  image: 'https://i.ibb.co/bMLdr9j9/Chat-GPT-Image-19-abr-2026-12-06-34.png'
}, {
  label: '30–36m',
  sublabel: 'Autonomía y social',
  image: 'https://i.ibb.co/zhv2vLhx/Chat-GPT-Image-19-abr-2026-12-07-14.png'
}];
const features = ['✅ Criterio profesional en cada sesión', '✅ 144 sesiones completas con objetivo y cierre', '✅ Fichas imprimibles + Checklists de seguimiento', '✅ Guiones para familias + Protocolos de alerta'];
export function ProductShowcase() {
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(240,249,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-256">
      <div className="mx-auto max-w-4xl text-center" data-id="element-257">
        {/* Badge */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-cyan-brand border border-cyan-brand/50 bg-cyan-brand/5 rounded-full px-4 py-1.5" data-id="element-258">
          🏆 El sistema más completo de Estimulación Temprana
        </div>

        {/* Subtitle */}
        <h3 className="text-xl font-bold text-cyan-brand m-0 mb-4" data-id="element-259">
          MEGAPACK ESTIMULACIÓN TEMPRANA
        </h3>

        {/* Description */}
        <p className="max-w-2xl text-gray-800 m-0 mb-8 text-[14px]" data-id="element-260">
          <strong data-id="element-261">6 Tomos + 6 Bonos — 0 a 36 meses — Todo resuelto.</strong>
          <br data-id="element-262" />
          +380 páginas · 144 sesiones modelo · 24 fichas imprimibles ·
          Neurodesarrollo · Semáforo de alertas · Planificación · Seguimiento ·
          Guiones para familias · Protocolos de derivación. Funciona desde hoy.
        </p>

        {/* Tomes Grid */}
        <div className="relative mx-auto max-w-3xl mb-12" data-id="element-263">
          <div className="grid grid-cols-6 gap-3" data-id="element-264">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center gap-2" data-id="element-265">
                {/* Card con imagen real */}
                <div className="w-full aspect-[3/4] rounded-xl overflow-hidden shadow-lg border border-gray-100" data-id="element-266">
                  <img src={tome.image} alt={`Tomo ${tome.label} — ${tome.sublabel}`} width={180} height={240} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-267" />
                </div>

                {/* Título separado abajo */}
                <div className="text-center" data-id="element-268">
                  <span className="block text-[11px] sm:text-xs font-black text-gray-900" data-id="element-269">
                    {tome.label}
                  </span>
                  <span className="block text-[9px] sm:text-[10px] text-gray-500 leading-tight mt-0.5" data-id="element-270">
                    {tome.sublabel}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Badge inferior */}
          <div className="mt-6 flex justify-center" data-id="element-271">
            <div className="whitespace-nowrap bg-cyan-brand text-[10px] font-black text-white rounded-full px-4 py-1.5 shadow-sm" data-id="element-272">
              6 TOMOS COMPLETOS · 0 A 36 MESES
            </div>
          </div>
        </div>

        {/* Feature Tags */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-273">
          {features.map(feature => <div key={feature} className="flex items-center gap-2.5 bg-cyan-brand/5 border border-cyan-brand/20 rounded-xl px-4 py-3 text-left" data-id="element-274">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-cyan-brand/15 flex items-center justify-center" data-id="element-275">
                <svg className="w-3 h-3 text-cyan-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-276">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-277" />
                </svg>
              </span>
              <span className="text-xs font-semibold text-gray-800 leading-snug" data-id="element-278">
                {feature.replace('✅ ', '')}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}